module.exports = __webpack_public_path__ + "static/media/recommender3.4e458cbc.png";